import React from 'react';

// Simulating the `item` generic
import PropTypes from "prop-types";
export var DefaultItemActionProps = function DefaultItemActionProps() {
  return ___EmotionJSX("div", null);
};
DefaultItemActionProps.propTypes = {
  /**
     * The type of action
     */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button"]), PropTypes.oneOf(["icon"]).isRequired]),
  /**
     * Defines the color of the button
     */
  color: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.func.isRequired]),
  /**
     * The display name of the action (will render as visible text if rendered within a collapsed menu)
     */
  /**
     * The display name of the action (will render as visible text if rendered within a collapsed menu)
     */
  name: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.func.isRequired]).isRequired,
  /**
     * Describes the action (will render as tooltip content)
     */
  /**
     * Describes the action (will render as tooltip content)
     */
  description: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]).isRequired,
  /**
     * A handler function to execute the action. Passes back the current row
     * item as the first argument, and the originating React click event
     * as a second argument.
     */
  /**
     * A handler function to execute the action. Passes back the current row
     * item as the first argument, and the originating React click event
     * as a second argument.
     */
  onClick: PropTypes.func,
  href: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]),
  target: PropTypes.string,
  /**
     * A callback function that determines whether the action is available
     */
  /**
     * A callback function that determines whether the action is available
     */
  available: PropTypes.func,
  /**
     * A callback function that determines whether the action is enabled
     */
  /**
     * A callback function that determines whether the action is enabled
     */
  enabled: PropTypes.func,
  "data-test-subj": PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.func.isRequired]),
  /**
     * If more than 3 actions are passed, 2 primary actions will show (on hover)
     * next to an expansion menu of all actions.
     *
     * On mobile, primary actions will be tucked away in the expansion menu for space.
     */
  /**
     * If more than 3 actions are passed, 2 primary actions will show (on hover)
     * next to an expansion menu of all actions.
     *
     * On mobile, primary actions will be tucked away in the expansion menu for space.
     */
  isPrimary: PropTypes.bool,
  /**
     * Allows only showing the action on mouse hover or keyboard focus.
     * If more than 3 actions are passed, this will always be true for `isPrimary` actions.
     *
     * Has no effect on mobile, or if `hasActions` is not set.
     */
  /**
     * Allows only showing the action on mouse hover or keyboard focus.
     * If more than 3 actions are passed, this will always be true for `isPrimary` actions.
     *
     * Has no effect on mobile, or if `hasActions` is not set.
     */
  showOnHover: PropTypes.bool,
  /**
     * Associates an icon with the button
     */
  icon: PropTypes.oneOfType([PropTypes.oneOf(["accessibility", "addDataApp", "advancedSettingsApp", "agentApp", "aggregate", "analyzeEvent", "annotation", "anomalyChart", "anomalySwimLane", "apmApp", "apmTrace", "appSearchApp", "apps", "arrowDown", "arrowLeft", "arrowRight", "arrowUp", "arrowStart", "arrowEnd", "article", "asterisk", "at", "auditbeatApp", "beaker", "bell", "bellSlash", "beta", "bolt", "boxesHorizontal", "boxesVertical", "branch", "branchUser", "broom", "brush", "bug", "bullseye", "calendar", "canvasApp", "casesApp", "changePointDetection", "check", "checkInCircleFilled", "cheer", "classificationJob", "clickLeft", "clickRight", "clock", "clockCounter", "cloudDrizzle", "cloudStormy", "cloudSunny", "cluster", "codeApp", "color", "compute", "console", "consoleApp", "container", "continuityAbove", "continuityAboveBelow", "continuityBelow", "continuityWithin", "controlsHorizontal", "controlsVertical", "copy", "copyClipboard", "createAdvancedJob", "createMultiMetricJob", "createPopulationJob", "createSingleMetricJob", "cross", "crossClusterReplicationApp", "crossInCircle", "crosshairs", "currency", "cut", "dashboardApp", "dataVisualizer", "database", "desktop", "devToolsApp", "diff", "discoverApp", "discuss", "document", "documentEdit", "documentation", "documents", "dot", "dotInCircle", "doubleArrowLeft", "doubleArrowRight", "download", "editorAlignCenter", "editorAlignLeft", "editorAlignRight", "editorBold", "editorChecklist", "editorCodeBlock", "editorComment", "editorDistributeHorizontal", "editorDistributeVertical", "editorHeading", "editorItalic", "editorItemAlignBottom", "editorItemAlignCenter", "editorItemAlignLeft", "editorItemAlignMiddle", "editorItemAlignRight", "editorItemAlignTop", "editorLink", "editorOrderedList", "editorPositionBottomLeft", "editorPositionBottomRight", "editorPositionTopLeft", "editorPositionTopRight", "editorRedo", "editorStrike", "editorTable", "editorUnderline", "editorUndo", "editorUnorderedList", "email", "empty", "emsApp", "endpoint", "eql", "eraser", "error", "errorFilled", "esqlVis", "exit", "expand", "expandMini", "exportAction", "eye", "eyeClosed", "faceHappy", "faceNeutral", "faceSad", "fieldStatistics", "filebeatApp", "filter", "filterExclude", "filterIgnore", "filterInclude", "filterInCircle", "flag", "fleetApp", "fold", "folderCheck", "folderClosed", "folderExclamation", "folderOpen", "frameNext", "framePrevious", "fullScreen", "fullScreenExit", "function", "gear", "gisApp", "glasses", "globe", "grab", "grabHorizontal", "grabOmnidirectional", "gradient", "graphApp", "grid", "grokApp", "heart", "heartbeatApp", "heatmap", "help", "home", "iInCircle", "image", "importAction", "index", "indexClose", "indexEdit", "indexFlush", "indexManagementApp", "indexMapping", "indexOpen", "indexPatternApp", "indexRollupApp", "indexRuntime", "indexSettings", "indexTemporary", "infinity", "inputOutput", "inspect", "invert", "ip", "key", "keyboard", "kqlField", "kqlFunction", "kqlOperand", "kqlSelector", "kqlValue", "kubernetesNode", "kubernetesPod", "launch", "layers", "lensApp", "lettering", "lineDashed", "lineDotted", "lineSolid", "link", "list", "listAdd", "lock", "lockOpen", "logPatternAnalysis", "logRateAnalysis", "logoAWS", "logoAWSMono", "logoAerospike", "logoApache", "logoAppSearch", "logoAzure", "logoAzureMono", "logoBeats", "logoBusinessAnalytics", "logoCeph", "logoCloud", "logoCloudEnterprise", "logoCode", "logoCodesandbox", "logoCouchbase", "logoDocker", "logoDropwizard", "logoElastic", "logoElasticStack", "logoElasticsearch", "logoEnterpriseSearch", "logoEtcd", "logoGCP", "logoGCPMono", "logoGithub", "logoGmail", "logoGolang", "logoGoogleG", "logoHAproxy", "logoIBM", "logoIBMMono", "logoKafka", "logoKibana", "logoKubernetes", "logoLogging", "logoLogstash", "logoMaps", "logoMemcached", "logoMetrics", "logoMongodb", "logoMySQL", "logoNginx", "logoObservability", "logoOsquery", "logoPhp", "logoPostgres", "logoPrometheus", "logoRabbitmq", "logoRedis", "logoSecurity", "logoSiteSearch", "logoSketch", "logoSlack", "logoUptime", "logoVulnerabilityManagement", "logoWebhook", "logoWindows", "logoWorkplaceSearch", "logsApp", "logstashFilter", "logstashIf", "logstashInput", "logstashOutput", "logstashQueue", "machineLearningApp", "magnet", "magnifyWithExclamation", "magnifyWithMinus", "magnifyWithPlus", "managementApp", "mapMarker", "memory", "menu", "menuDown", "menuLeft", "menuRight", "menuUp", "merge", "metricbeatApp", "metricsApp", "minimize", "minus", "minusInCircle", "minusInCircleFilled", "minusInSquare", "mobile", "monitoringApp", "moon", "move", "namespace", "nested", "newChat", "node", "notebookApp", "number", "offline", "online", "outlierDetectionJob", "package", "packetbeatApp", "pageSelect", "pagesSelect", "palette", "paperClip", "partial", "pause", "payment", "pencil", "percent", "pin", "pinFilled", "pipeBreaks", "pipelineApp", "pipeNoBreaks", "pivot", "play", "playFilled", "plus", "plusInCircle", "plusInCircleFilled", "plusInSquare", "popout", "push", "questionInCircle", "quote", "recentlyViewedApp", "refresh", "regressionJob", "reporter", "reportingApp", "returnKey", "save", "savedObjectsApp", "scale", "search", "searchProfilerApp", "securityAnalyticsApp", "securityApp", "securitySignal", "securitySignalDetected", "securitySignalResolved", "sessionViewer", "shard", "share", "singleMetricViewer", "snowflake", "sortAscending", "sortDescending", "sortDown", "sortLeft", "sortRight", "sortUp", "sortable", "spaces", "spacesApp", "sparkles", "sqlApp", "starEmpty", "starEmptySpace", "starFilled", "starFilledSpace", "starMinusEmpty", "starMinusFilled", "starPlusEmpty", "starPlusFilled", "stats", "stop", "stopFilled", "stopSlash", "storage", "string", "submodule", "sun", "swatchInput", "symlink", "tableDensityCompact", "tableDensityExpanded", "tableDensityNormal", "tableOfContents", "tag", "tear", "temperature", "timeline", "timelineWithArrow", "timelionApp", "timeRefresh", "timeslider", "training", "transitionLeftIn", "transitionLeftOut", "transitionTopIn", "transitionTopOut", "trash", "unfold", "unlink", "upgradeAssistantApp", "uptimeApp", "user", "userAvatar", "users", "usersRolesApp", "vector", "videoPlayer", "visArea", "visAreaStacked", "visBarHorizontal", "visBarHorizontalStacked", "visBarVertical", "visBarVerticalStacked", "visGauge", "visGoal", "visLine", "visMapCoordinate", "visMapRegion", "visMetric", "visPie", "visTable", "visTagCloud", "visText", "visTimelion", "visVega", "visVisualBuilder", "visualizeApp", "vulnerabilityManagementApp", "warning", "warningFilled", "alert", "watchesApp", "wordWrap", "wordWrapDisabled", "workplaceSearchApp", "wrench", "tokenAlias", "tokenAnnotation", "tokenArray", "tokenBinary", "tokenBoolean", "tokenClass", "tokenCompletionSuggester", "tokenConstant", "tokenDate", "tokenDimension", "tokenElement", "tokenEnum", "tokenEnumMember", "tokenEvent", "tokenException", "tokenField", "tokenFile", "tokenFlattened", "tokenFunction", "tokenGeo", "tokenHistogram", "tokenInterface", "tokenIP", "tokenJoin", "tokenKey", "tokenKeyword", "tokenMethod", "tokenMetricCounter", "tokenMetricGauge", "tokenModule", "tokenNamespace", "tokenNested", "tokenNull", "tokenNumber", "tokenObject", "tokenOperator", "tokenPackage", "tokenParameter", "tokenPercolator", "tokenProperty", "tokenRange", "tokenRankFeature", "tokenRankFeatures", "tokenRepo", "tokenSearchType", "tokenShape", "tokenString", "tokenStruct", "tokenSymbol", "tokenTag", "tokenText", "tokenTokenCount", "tokenVariable", "tokenVectorDense", "tokenDenseVector", "tokenVectorSparse"]).isRequired, PropTypes.func.isRequired])
};
export var SearchProps = function SearchProps() {
  return ___EmotionJSX("div", null);
};
SearchProps.propTypes = [PropTypes.bool.isRequired, PropTypes.shape({
  onChange: PropTypes.func,
  /**
     The initial query the bar will hold when first mounted
     */
  defaultQuery: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.string.isRequired]),
  /**
     If you wish to use the search bar as a controlled component, continuously pass the query via this prop.
     */
  query: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.string.isRequired]),
  /**
     Configures the search box. Set `placeholder` to change the placeholder text in the box and `incremental` to support incremental (as you type) search.
     */
  box: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    isInvalid: PropTypes.bool,
    /**
       * Expand to fill 100% of the parent.
       * Defaults to `fullWidth` prop of `<EuiForm>`.
       * @default false
       */
    fullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
    /**
       * Called when the user presses [Enter] OR on change if the incremental prop is `true`.
       * If you don't need the on[Enter] functionality, prefer using onChange
       */
    onSearch: PropTypes.func,
    /**
       * When `true` the search will be executed (that is, the `onSearch` will be called) as the
       * user types.
       */
    incremental: PropTypes.bool,
    /**
       * when `true` creates a shorter height input
       */
    compressed: PropTypes.bool,
    inputRef: PropTypes.func,
    /**
       * Shows a button that quickly clears any input
       */
    isClearable: PropTypes.bool,
    /**
       * Creates an input group with element(s) coming before input
       * `string` | `ReactElement` or an array of these
       */
    prepend: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired).isRequired]),
    /**
       * Creates an input group with element(s) coming after input.
       * `string` | `ReactElement` or an array of these
       */
    append: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired).isRequired]),
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string,
    css: PropTypes.any,
    // Boolean values are not meaningful to this EuiSearchBox, but are allowed so that other
    // components can use e.g. a true value to mean "auto-derive a schema". See EuiInMemoryTable.
    // Admittedly, this is a bit of a hack.
    schema: PropTypes.oneOfType([PropTypes.shape({
      strict: PropTypes.bool,
      fields: PropTypes.any,
      flags: PropTypes.arrayOf(PropTypes.string.isRequired)
    }).isRequired, PropTypes.bool.isRequired])
  }),
  /**
     An array of search filters. See #SearchFilterConfig.
     */
  filters: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    type: PropTypes.oneOf(["is"]).isRequired,
    field: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    available: PropTypes.func
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_selection"]).isRequired,
    field: PropTypes.string,
    name: PropTypes.string.isRequired,
    /**
       * See #FieldValueOptionType
       */
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
        type: PropTypes.oneOf(["date"]).isRequired,
        raw: PropTypes.any.isRequired,
        granularity: PropTypes.oneOfType([PropTypes.shape({
          es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
          js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
          isSame: PropTypes.func.isRequired,
          start: PropTypes.func.isRequired,
          startOfNext: PropTypes.func.isRequired,
          iso8601: PropTypes.func.isRequired
        }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
        text: PropTypes.string.isRequired,
        resolve: PropTypes.func.isRequired
      }).isRequired]).isRequired,
      name: PropTypes.string,
      view: PropTypes.node
    }).isRequired).isRequired, PropTypes.func.isRequired]).isRequired,
    filterWith: PropTypes.oneOfType([PropTypes.oneOf(["prefix", "includes"]), PropTypes.func.isRequired]),
    cache: PropTypes.number,
    multiSelect: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["and", "or"])]),
    loadingMessage: PropTypes.string,
    noOptionsMessage: PropTypes.string,
    searchThreshold: PropTypes.number,
    available: PropTypes.func,
    autoClose: PropTypes.bool,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_toggle"]).isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
      type: PropTypes.oneOf(["date"]).isRequired,
      raw: PropTypes.any.isRequired,
      granularity: PropTypes.oneOfType([PropTypes.shape({
        es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
        js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
        isSame: PropTypes.func.isRequired,
        start: PropTypes.func.isRequired,
        startOfNext: PropTypes.func.isRequired,
        iso8601: PropTypes.func.isRequired
      }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
      text: PropTypes.string.isRequired,
      resolve: PropTypes.func.isRequired
    }).isRequired]).isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    available: PropTypes.func,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_toggle_group"]).isRequired,
    field: PropTypes.string.isRequired,
    /**
       * See #FieldValueToggleGroupFilterItemType
       */
    items: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
      name: PropTypes.string.isRequired,
      negatedName: PropTypes.string,
      operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
    }).isRequired).isRequired,
    available: PropTypes.func
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["custom_component"]).isRequired,
    component: PropTypes.elementType.isRequired,
    available: PropTypes.func
  }).isRequired]).isRequired),
  /**
     * Tools which go to the left of the search bar.
     */
  toolsLeft: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired]),
  /**
     * Tools which go to the right of the search bar.
     */
  toolsRight: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired]),
  /**
     * Date formatter to use when parsing date values
     */
  dateFormat: PropTypes.any,
  /**
     * Hint to render below the search bar
     */
  hint: PropTypes.shape({
    content: PropTypes.node.isRequired,
    popoverProps: PropTypes.any
  }),
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  css: PropTypes.any
}).isRequired];
export var SearchFilterConfigProps = function SearchFilterConfigProps() {
  return ___EmotionJSX("div", null);
};
SearchFilterConfigProps.propTypes = [PropTypes.shape({
  type: PropTypes.oneOf(["is"]).isRequired,
  field: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  negatedName: PropTypes.string,
  available: PropTypes.func
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_selection"]).isRequired,
  field: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
      type: PropTypes.oneOf(["date"]).isRequired,
      raw: PropTypes.any.isRequired,
      granularity: PropTypes.oneOfType([PropTypes.shape({
        es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
        js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
        isSame: PropTypes.func.isRequired,
        start: PropTypes.func.isRequired,
        startOfNext: PropTypes.func.isRequired,
        iso8601: PropTypes.func.isRequired
      }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
      text: PropTypes.string.isRequired,
      resolve: PropTypes.func.isRequired
    }).isRequired]).isRequired,
    name: PropTypes.string,
    view: PropTypes.node
  }).isRequired).isRequired, PropTypes.func.isRequired]).isRequired,
  filterWith: PropTypes.oneOfType([PropTypes.oneOf(["prefix", "includes"]), PropTypes.func.isRequired]),
  cache: PropTypes.number,
  multiSelect: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["and", "or"])]),
  loadingMessage: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  searchThreshold: PropTypes.number,
  available: PropTypes.func,
  autoClose: PropTypes.bool,
  operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_toggle"]).isRequired,
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["date"]).isRequired,
    raw: PropTypes.any.isRequired,
    granularity: PropTypes.oneOfType([PropTypes.shape({
      es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
      js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
      isSame: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      startOfNext: PropTypes.func.isRequired,
      iso8601: PropTypes.func.isRequired
    }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
    text: PropTypes.string.isRequired,
    resolve: PropTypes.func.isRequired
  }).isRequired]).isRequired,
  name: PropTypes.string.isRequired,
  negatedName: PropTypes.string,
  available: PropTypes.func,
  operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_toggle_group"]).isRequired,
  field: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired).isRequired,
  available: PropTypes.func
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["custom_component"]).isRequired,
  component: PropTypes.elementType.isRequired,
  available: PropTypes.func
}).isRequired];
export var EuiTableRowCellMobileOptionsShape = function EuiTableRowCellMobileOptionsShape() {
  return ___EmotionJSX("div", null);
};
export var EuiTableComputedColumnType = function EuiTableComputedColumnType() {
  return ___EmotionJSX("div", null);
};
export var EuiTableActionsColumnType = () => <div />;
try {
  DefaultItemActionProps.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'DefaultItemActionProps',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: 'The type of action',
        name: 'type',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        }, {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemEmptyButtonAction'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"button" | "icon"',
          value: [{
            value: '"button"'
          }, {
            value: '"icon"'
          }]
        }
      },
      icon: {
        defaultValue: null,
        description: 'Associates an icon with the button',
        name: 'icon',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        }],
        required: false,
        type: {
          name: '"string" | "number" | "function" | "fullScreen" | "color" | "search" | "link" | "at" | "article" | "menu" | "filter" | "image" | "stop" | "error" | "pause" | "play" | "offline" | ... 489 more ... | IconFunction<...>'
        }
      },
      color: {
        defaultValue: null,
        description: 'Defines the color of the button',
        name: 'color',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        }, {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemEmptyButtonAction'
        }],
        required: false,
        type: {
          name: '"text" | "accent" | "primary" | "success" | "warning" | "danger" | EuiButtonIconColorFunction<T>'
        }
      },
      name: {
        defaultValue: null,
        description: 'The display name of the action (will render as visible text if rendered within a collapsed menu)',
        name: 'name',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: true,
        type: {
          name: 'ReactNode | ((item: T) => ReactNode)'
        }
      },
      description: {
        defaultValue: null,
        description: 'Describes the action (will render as tooltip content)',
        name: 'description',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: true,
        type: {
          name: 'string | ((item: T) => string)'
        }
      },
      onClick: {
        defaultValue: null,
        description: 'A handler function to execute the action. Passes back the current row\n' + 'item as the first argument, and the originating React click event\n' + 'as a second argument.',
        name: 'onClick',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: '(item: T, event: MouseEvent<Element, MouseEvent>) => void'
        }
      },
      href: {
        defaultValue: null,
        description: '',
        name: 'href',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'string | ((item: T) => string)'
        }
      },
      target: {
        defaultValue: null,
        description: '',
        name: 'target',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      available: {
        defaultValue: null,
        description: 'A callback function that determines whether the action is available',
        name: 'available',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: '(item: T) => boolean'
        }
      },
      enabled: {
        defaultValue: null,
        description: 'A callback function that determines whether the action is enabled',
        name: 'enabled',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: '(item: T) => boolean'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'string | ((item: T) => string)'
        }
      },
      isPrimary: {
        defaultValue: null,
        description: 'If more than 3 actions are passed, 2 primary actions will show (on hover)\n' + 'next to an expansion menu of all actions.\n' + '\n' + 'On mobile, primary actions will be tucked away in the expansion menu for space.',
        name: 'isPrimary',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      showOnHover: {
        defaultValue: null,
        description: 'Allows only showing the action on mouse hover or keyboard focus.\n' + 'If more than 3 actions are passed, this will always be true for `isPrimary` actions.\n' + '\n' + 'Has no effect on mobile, or if `hasActions` is not set.',
        name: 'showOnHover',
        parent: {
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'TdHTMLAttributes', 'EuiTableFieldDataColumnType']
  };
} catch (e) {}
try {
  SearchProps.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'SearchProps',
    methods: [],
    props: {
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: '(args: EuiSearchBarOnChangeArgs) => boolean | void'
        }
      },
      defaultQuery: {
        defaultValue: null,
        description: 'The initial query the bar will hold when first mounted',
        name: 'defaultQuery',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'QueryType'
        }
      },
      query: {
        defaultValue: null,
        description: 'If you wish to use the search bar as a controlled component, continuously pass the query via this prop.',
        name: 'query',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'QueryType'
        }
      },
      box: {
        defaultValue: null,
        description: 'Configures the search box. Set `placeholder` to change the placeholder text in the box and `incremental` to support incremental (as you type) search.',
        name: 'box',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'EuiFieldSearchProps & { schema?: boolean | SchemaType; }'
        }
      },
      filters: {
        defaultValue: null,
        description: 'An array of search filters. See #SearchFilterConfig.',
        name: 'filters',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'SearchFilterConfig[]'
        }
      },
      toolsLeft: {
        defaultValue: null,
        description: 'Tools which go to the left of the search bar.',
        name: 'toolsLeft',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'Tools'
        }
      },
      toolsRight: {
        defaultValue: null,
        description: 'Tools which go to the right of the search bar.',
        name: 'toolsRight',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'Tools'
        }
      },
      dateFormat: {
        defaultValue: null,
        description: 'Date formatter to use when parsing date values',
        name: 'dateFormat',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: 'object'
        }
      },
      hint: {
        defaultValue: null,
        description: 'Hint to render below the search bar',
        name: 'hint',
        parent: {
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        }],
        required: false,
        type: {
          name: '{ content: React.ReactNode; popoverProps?: Partial<Pick<EuiInputPopoverProps, "data-test-subj" | "fullWidth" | "isOpen" | "closePopover" | "panelClassName" | "panelPaddingSize" | ... 5 more ... | "disableFocusTrap">>; }'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'TdHTMLAttributes', 'EuiTableFieldDataColumnType']
  };
} catch (e) {}
try {
  SearchFilterConfigProps.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'SearchFilterConfigProps',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        }],
        required: true,
        type: {
          name: 'enum',
          raw: '"is" | "field_value_selection" | "field_value_toggle" | "field_value_toggle_group" | "custom_component"',
          value: [{
            value: '"is"'
          }, {
            value: '"field_value_selection"'
          }, {
            value: '"field_value_toggle"'
          }, {
            value: '"field_value_toggle_group"'
          }, {
            value: '"custom_component"'
          }]
        }
      },
      field: {
        defaultValue: null,
        description: '',
        name: 'field',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      name: {
        defaultValue: null,
        description: '',
        name: 'name',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      negatedName: {
        defaultValue: null,
        description: '',
        name: 'negatedName',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      available: {
        defaultValue: null,
        description: '',
        name: 'available',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        }],
        required: false,
        type: {
          name: '(() => boolean) | (() => boolean) | (() => boolean) | (() => boolean) | (() => boolean)'
        }
      },
      options: {
        defaultValue: null,
        description: 'See #FieldValueOptionType',
        name: 'options',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: true,
        type: {
          name: 'FieldValueOptionType[] | OptionsLoader'
        }
      },
      filterWith: {
        defaultValue: null,
        description: '',
        name: 'filterWith',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: '"prefix" | "includes" | OptionsFilter'
        }
      },
      cache: {
        defaultValue: null,
        description: '',
        name: 'cache',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      multiSelect: {
        defaultValue: null,
        description: '',
        name: 'multiSelect',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'MultiSelect'
        }
      },
      loadingMessage: {
        defaultValue: null,
        description: '',
        name: 'loadingMessage',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      noOptionsMessage: {
        defaultValue: null,
        description: '',
        name: 'noOptionsMessage',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      searchThreshold: {
        defaultValue: null,
        description: '',
        name: 'searchThreshold',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'number'
        }
      },
      autoClose: {
        defaultValue: null,
        description: '',
        name: 'autoClose',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      operator: {
        defaultValue: null,
        description: '',
        name: 'operator',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        }, {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'OperatorType',
          value: [{
            value: '"eq"'
          }, {
            value: '"exact"'
          }, {
            value: '"gt"'
          }, {
            value: '"gte"'
          }, {
            value: '"lt"'
          }, {
            value: '"lte"'
          }]
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        }],
        required: true,
        type: {
          name: 'Value'
        }
      },
      items: {
        defaultValue: null,
        description: 'See #FieldValueToggleGroupFilterItemType',
        name: 'items',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        }],
        required: true,
        type: {
          name: 'FieldValueToggleGroupFilterItemType[]'
        }
      },
      component: {
        defaultValue: null,
        description: '',
        name: 'component',
        parent: {
          fileName: 'eui/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        },
        declarations: [{
          fileName: 'eui/src/components/search_bar/filters/custom_component_filter.tsx',
          name: 'CustomComponentFilterConfigType'
        }],
        required: true,
        type: {
          name: 'React.ComponentType<T>'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'TdHTMLAttributes', 'EuiTableFieldDataColumnType']
  };
} catch (e) {}
try {
  EuiTableRowCellMobileOptionsShape.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'EuiTableRowCellMobileOptionsShape',
    methods: [],
    props: {
      show: {
        defaultValue: {
          value: 'true'
        },
        description: 'If false, will not render the cell at all for mobile',
        name: 'show',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      only: {
        defaultValue: {
          value: 'false'
        },
        description: 'Only show for mobile? If true, will not render the column at all for desktop',
        name: 'only',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      render: {
        defaultValue: null,
        description: 'Custom render/children if different from desktop',
        name: 'render',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      header: {
        defaultValue: null,
        description: "The column's header for use in mobile view (automatically passed down\n" + 'when using `EuiBasicTable`).\n' + 'Or pass `false` to not show a header at all.',
        name: 'header',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      enlarge: {
        defaultValue: {
          value: 'false'
        },
        description: 'Increase text size compared to rest of cells',
        name: 'enlarge',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      width: {
        defaultValue: {
          value: '50%'
        },
        description: 'Applies the value to the width of the cell in mobile view (typically 50%)',
        name: 'width',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellMobileOptionsShape'
        }],
        required: false,
        type: {
          name: 'Width<string | number>'
        }
      },
      align: {
        defaultValue: null,
        description: 'Horizontal alignment of the text in the cell',
        name: 'align',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'HorizontalAlignment',
          value: [{
            value: '"center"'
          }, {
            value: '"left"'
          }, {
            value: '"right"'
          }]
        }
      },
      textOnly: {
        defaultValue: {
          value: 'true'
        },
        description: 'Creates a text wrapper around cell content that helps word break or truncate\n' + 'long text correctly.',
        name: 'textOnly',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      truncateText: {
        defaultValue: {
          value: 'false'
        },
        description: 'Indicates whether this column should truncate overflowing text content.\n' + '- Set to `true` to enable single-line truncation.\n' + '- To enable multi-line truncation, use a configuration object with `lines`\n' + 'set to a number of lines to truncate to.',
        name: 'truncateText',
        parent: {
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        },
        declarations: [{
          fileName: 'eui/src/components/table/table_row_cell.tsx',
          name: 'EuiTableRowCellSharedPropsShape'
        }],
        required: false,
        type: {
          name: 'boolean | { lines: number; }'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'TdHTMLAttributes', 'EuiTableFieldDataColumnType']
  };
} catch (e) {}
try {
  EuiTableComputedColumnType.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'EuiTableComputedColumnType',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'eui/node_modules/@types/react/ts5.0/index.d.ts',
          name: 'HTMLAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'eui/node_modules/@types/react/ts5.0/index.d.ts',
          name: 'AriaAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      },
      render: {
        defaultValue: null,
        description: 'A function that computes the value for each item and renders it',
        name: 'render',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: '(record: T) => ReactNode'
        }
      },
      name: {
        defaultValue: null,
        description: 'The display name of the column',
        name: 'name',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      sortable: {
        defaultValue: null,
        description: 'If provided, allows this column to be sorted on. Must return the value to sort against.',
        name: 'sortable',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '(item: T) => Primitive'
        }
      },
      description: {
        defaultValue: null,
        description: 'A description of the column (will be presented as a title over the column header)',
        name: 'description',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      width: {
        defaultValue: null,
        description: 'A CSS width property. Hints for the required width of the column (e.g. "30%", "100px", etc..)',
        name: 'width',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      readOnly: {
        defaultValue: null,
        description: "Disables the user's ability to change the sort, but will still\n" + 'show the current sort direction in the column header',
        name: 'readOnly',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      align: {
        defaultValue: {
          value: 'left'
        },
        description: 'Defines the horizontal alignment of the column',
        name: 'align',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: 'HorizontalAlignment',
          value: [{
            value: '"center"'
          }, {
            value: '"left"'
          }, {
            value: '"right"'
          }]
        }
      },
      isExpander: {
        defaultValue: null,
        description: 'If passing `itemIdToExpandedRowMap` to your table, set this flag to `true`\n' + 'for the custom column or cell used to toggle the expanded row.',
        name: 'isExpander',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      truncateText: {
        defaultValue: null,
        description: 'Indicates whether this column should truncate overflowing text content.\n' + '- Set to `true` to enable single-line truncation.\n' + '- To enable multi-line truncation, use a configuration object with `lines`\n' + 'set to a number of lines to truncate to.',
        name: 'truncateText',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'boolean | { lines: number; }'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'TdHTMLAttributes', 'EuiTableFieldDataColumnType']
  };
} catch (e) {}
try {
  EuiTableActionsColumnType.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/tables/props/props.tsx',
    description: '',
    displayName: 'EuiTableActionsColumnType',
    methods: [],
    props: {
      actions: {
        defaultValue: null,
        description: 'An array of one of the objects: #DefaultItemAction or #CustomItemAction',
        name: 'actions',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'Action<T>[]'
        }
      },
      name: {
        defaultValue: null,
        description: 'The display name of the column',
        name: 'name',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      description: {
        defaultValue: null,
        description: 'A description of the column (will be presented as a title over the column header)',
        name: 'description',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      width: {
        defaultValue: null,
        description: 'A CSS width property. Hints for the required width of the column (e.g. "30%", "100px", etc..)',
        name: 'width',
        parent: {
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        },
        declarations: [{
          fileName: 'eui/src/components/basic_table/table_types.ts',
          name: 'EuiTableFieldDataColumnType'
        }],
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType', 'CustomComponentFilterConfigType', 'EuiTableRowCellMobileOptionsShape', 'EuiTableRowCellSharedPropsShape', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes', 'TdHTMLAttributes', 'EuiTableFieldDataColumnType']
  };
} catch (e) {}